// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function ImagesInfoCarousel() {

    var self = this,
      $el = null,
      $imagesInfoCarousel = null,
      $imagesCarouselSlide = null,
      $infoCarouselSlide = null,
      $imagesCarouselDataIndexNb = null,
      totalSlidesWidth = 0,

      options = {
        example: null,
      };


    /**
     * Init Images Carousel
     */
    function initImagesCarousel() {
      var offset           = 0,
          centeredSlides   = false,
          loop             = true;

      // If total images slides width < carousel width
      if(totalSlidesWidth < $('.js-images-carousel-slider').width()) {
        if(!$('.js-images-info-carousel').hasClass('is-reverse')) {
          offset = $('.js-images-carousel').width() - $('.images-info-carousel__slide').outerWidth();
        } else {
          // Centered actived + set negative offset + remove loop
          offset = -($('.js-images-carousel-slider').outerWidth() - $('.js-images-carousel-slider .swiper-slide').first().outerWidth())/2;
          centeredSlides = true;
          loop = false;
        }
      }

      // If images carousel left position : set offset to have align-right
      if(!$('.js-images-info-carousel').hasClass('is-reverse')) {
         offset = $('.js-images-carousel').width() - $('.images-info-carousel__slide').outerWidth();
      }

      var imagesCarousel = new Swiper('.js-images-carousel', {
        loop: loop,
        slidesPerView: 'auto',
        slidesOffsetBefore: offset,
        centeredSlides: centeredSlides,
        speed: 1000,
        allowTouchMove: false,
        autoplay: {
          delay: 4000,
        },
        navigation: {
          nextEl: '.js-images-carousel-button-next',
          prevEl: '.js-images-carousel-button-prev',
        },
        pagination: {
          el: '.js-images-carousel-pagination',
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          991: {
            loop: true,
            slidesOffsetBefore: 0,
            centeredSlides: true
          },
        }
      });
    }

    /**
     * Init Info Carousel
     */
    function initInfoCarousel() {
      var loop = true;

      // If total images slides width < carousel width : remove loop
      if(totalSlidesWidth < $('.js-images-carousel-slider').width()) {
         loop = false;
      }

      var infoCarousel = new Swiper('.js-info-carousel', {
        loop: loop,
        slidesPerView: 1,
        speed: 1000,
        allowTouchMove: false,
        autoplay: {
          delay: 4000,
        },
        navigation: {
          nextEl: '.js-images-carousel-button-next',
          prevEl: '.js-images-carousel-button-prev',
        },
        pagination: {
          el: '.js-images-carousel-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    }


    /**
     * Generic resize
     */
    function onResize() {
      // Example
      if (window.bp.getLastValue() !== window.bp.getValue()) {
        if (window.bp.getValue() === 'lg' || window.bp.getValue() === 'xl') {
        }
      }
    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      // extends options
      for (var i in opts) { options[i] = opts[i]; }


      // Caching
      $el = options.$el;
      $imagesInfoCarousel = $('.js-images-info-carousel');
      $imagesCarouselSlide = $('.js-images-carousel .swiper-slide');
      $infoCarouselSlide = $('.js-info-carousel .swiper-slide');

      // Get all slides width
      $imagesCarouselSlide.each(function(index){
        totalSlidesWidth += $(this).width();
      });

      // Init Images Carousel
      if($imagesCarouselSlide.length > 1) {
        initImagesCarousel();
      } 

      // Init Info Carousel
      if($infoCarouselSlide.length > 1) {
        initInfoCarousel();
      }

      // No swiper
      if($imagesCarouselSlide.length < 2 && $infoCarouselSlide.length < 2) {
        $imagesInfoCarousel.addClass('no-carousel');
      }

      // Only images
      if($imagesCarouselSlide.length > 1 && $infoCarouselSlide.length < 2) {
        $imagesInfoCarousel.addClass('out-nav');
      }


      // *************
      window.cache.$window.on('resize', Utils.debounce(onResize, 3000));
      // Initial call on load
      onResize();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
   window.Components.ImagesInfoCarousel = ImagesInfoCarousel;

}(jQuery));
